import React, { useMemo } from 'react';
import Row from './Row/Row';
import VisibilitySensor from 'react-visibility-sensor';
import LeagueName from '../../../shared/Events/Table/Header/LeagueName/LeagueName';
import { useSelector } from 'react-redux';

const sortTypes = {
    1: 'startedAt',
    2: 'startedAt',
    3: 'mbn',
};

const Table = props => {
    const sortType = useSelector(state => state.favorites.sortType);

    const { events, categoryName, leagueName, countryCode } = props;

    const sortedEvents = useMemo(
        () => events.sort((a, b) => a[sortTypes[sortType]] - b[sortTypes[sortType]]),
        [sortType, events]
    );

    return (
        <table className={'common-table'}>
            {sortedEvents.length > 0 && leagueName ? (
                <thead>
                    <tr>
                        <LeagueName
                            categoryName={categoryName}
                            leagueName={leagueName}
                            countryCode={countryCode}
                        />
                    </tr>
                </thead>
            ) : null}
            <tbody>
                {sortedEvents.length > 0
                    ? sortedEvents.map(event => {
                          return (
                              <VisibilitySensor
                                  key={event.id}
                                  partialVisibility={true}
                                  scrollCheck={true}
                              >
                                  {({ isVisible }) => {
                                      return isVisible ? (
                                          <Row key={event.id} event={event} />
                                      ) : (
                                          <tr key={event.id} style={{ height: '87px' }} />
                                      );
                                  }}
                              </VisibilitySensor>
                          );
                      })
                    : null}
            </tbody>
        </table>
    );
};

export default Table;
